import React, { FC } from 'react'
import { ContactFormValuesEnum } from '../types/contactFormValuesEnum'
import { Field } from 'react-final-form'
import SelectField from '../../../components/fields/SelectField'
import { SelectOption } from '../../../types/fields/fieldsModel'
import { useIntl } from 'react-intl'
import { CivilityEnum } from '../types/civilityEnum'

const CivilityField: FC = () => {
	const intl = useIntl()

	const CIVILITIES: SelectOption[] = [{
		label: intl.formatMessage({
			id: 'creationContact.contactForm.mister',
			defaultMessage: 'M',
			description: 'Civility option'
		}),
		value: CivilityEnum.MONSIEUR
	}, {
		label: intl.formatMessage({
			id: 'creationContact.contactForm.miss',
			defaultMessage: 'Mme',
			description: 'Civility option'
		}),
		value: CivilityEnum.MADAME
	}]

	return (
		<Field
			name={ContactFormValuesEnum.CIVILITY}
			component={SelectField}
			label="creationContact.contactForm.civility"
			options={CIVILITIES}
		/>
	)
}
export default CivilityField